import React, { useState } from "react";
import { Button, Modal, Card, Tag, Typography, Space } from "antd";
import {
  FileTextOutlined,
  DownloadOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined
} from "@ant-design/icons";

const ContractDetailsModal = ({ contractData, isPanelChat, onDownload, onAccept }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const getStatusProps = (status) => {
    switch (status?.toLowerCase()) {
      case "pending":
        return {
          color: "orange",
          icon: <ClockCircleOutlined />,
          text: "Pending Review"
        };
      case "approved":
        return {
          color: "green",
          icon: <CheckCircleOutlined />,
          text: "Approved"
        };
      case "rejected":
        return {
          color: "red",
          icon: <ClockCircleOutlined />,
          text: "Rejected"
        };
      default:
        return {
          color: "default",
          icon: <FileTextOutlined />,
          text: "In Progress"
        };
    }
  };

  const statusProps = getStatusProps(contractData?.status);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <Button icon={<FileTextOutlined />} onClick={showModal}>
        View Contract
      </Button>

      <Modal
        title={
          <Space>
            <FileTextOutlined />
            <Typography.Text strong>Contract Details</Typography.Text>
          </Space>
        }
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={[
          <Button key="download" icon={<DownloadOutlined />} onClick={onDownload}>
            Download Contract
          </Button>,
          !isPanelChat && contractData?.status?.toLowerCase() === "pending" && (
            <Button
              key="accept"
              type="primary"
              icon={<CheckCircleOutlined />}
              onClick={() => {
                onAccept();
                handleCancel();
              }}>
              Accept Contract
            </Button>
          )
        ]}>
        <Card
          size="small"
          extra={
            <Tag color={statusProps.color}>
              {statusProps.icon} {statusProps.text}
            </Tag>
          }>
          <Space direction="vertical" size="middle" style={{ width: "100%" }}>
            <Typography.Paragraph>
              <strong>File Type:</strong>
              {" " + (contractData?.document?.file?.split(".").pop()?.toUpperCase() || "Unknown")}
            </Typography.Paragraph>

            <Typography.Paragraph>
              <strong>Uploaded On:</strong>
              {" " + (new Date(contractData?.createdAt).toLocaleDateString() || "N/A")}
            </Typography.Paragraph>
          </Space>
        </Card>
      </Modal>
    </>
  );
};

export default ContractDetailsModal;
